// Rollen und Module (Rahmen der Neuratek-Software: Module mit Umschalter, Rechte je Modul und Rolle; Prototyp MOD_ROLLE)

export const ROLLEN = ['admin', 'opener', 'closer', 'berater'] as const;
export type Rolle = (typeof ROLLEN)[number];

// Reihenfolge wie im Umschalter des Prototyps
// Cockpit zuerst: nur Leon, erster Eintrag im Umschalter und Startseite nach der Anmeldung (Leon 2026-10-29)
export const MODULE = ['cockpit', 'akquise', 'crm', 'buchhaltung', 'kunden'] as const;
export type Modul = (typeof MODULE)[number];

export const MODULE_JE_ROLLE: Record<Rolle, readonly Modul[]> = {
  admin: ['cockpit', 'akquise', 'crm', 'buchhaltung', 'kunden'],
  opener: ['crm'],
  closer: ['crm'],
  berater: ['crm', 'kunden']
};

export const MODUL_NAME: Record<Modul, { lang: string; kurz: string }> = {
  cockpit: { lang: 'Cockpit', kurz: 'Cockpit' },
  akquise: { lang: 'Akquise', kurz: 'Akq.' },
  crm: { lang: 'CRM', kurz: 'CRM' },
  buchhaltung: { lang: 'Buchhaltung', kurz: 'Buchh.' },
  kunden: { lang: 'Kunden', kurz: 'Kunden' }
};

export function istRolle(wert: unknown): wert is Rolle {
  return typeof wert === 'string' && (ROLLEN as readonly string[]).includes(wert);
}

/** Module, die ein Nutzer mit diesen Rollen sieht, in fester Reihenfolge. */
export function moduleFuer(rollen: readonly Rolle[]): Modul[] {
  return MODULE.filter(m => rollen.some(r => MODULE_JE_ROLLE[r].includes(m)));
}

/** Bezeichnung der Rolle wie im Prototyp („Closer und Berater“ bei beiden). */
export function rollenBezeichnung(rollen: readonly Rolle[]): string {
  if (rollen.includes('admin')) return 'Admin';
  const namen: Record<Rolle, string> = { admin: 'Admin', opener: 'Opener', closer: 'Closer', berater: 'Berater' };
  return ROLLEN.filter(r => rollen.includes(r)).map(r => namen[r]).join(' und ');
}

/** Kürzel für den Avatar: Anfangsbuchstaben von Vor- und Nachname. */
export function kuerzel(name: string): string {
  const teile = name.trim().split(/\s+/).filter(Boolean);
  if (!teile.length) return '?';
  const a = teile[0][0] ?? '';
  const b = teile.length > 1 ? teile[teile.length - 1][0] ?? '' : '';
  return (a + b).toUpperCase();
}

export interface Ich {
  id: number;
  email: string;
  name: string;
  kurz: string;
  rollen: Rolle[];
  module: Modul[];
}

export type Umgebung = 'entwicklung' | 'test' | 'echt';

export interface AnmeldeKonfig {
  umgebung: Umgebung;
  googleClientId: string | null;
  testanmeldung: boolean;
}
